// extracted by mini-css-extract-plugin
export default {"section":"role-quota-modal_section__dAr-D","loading":"role-quota-modal_loading__n1l5F","collapse":"role-quota-modal_collapse__oq9j7"};